var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearInReviewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2989 35.8263L14.3985 31.1479L5.50026 35.8263L7.20034 25.9172L0 18.8995L9.95046 17.4516L14.3985 8.43591L18.8487 17.4516L28.7992 18.8995L21.5988 25.9172L23.2989 35.8263ZM0.700027 19.1255L7.55035 25.802L5.93289 35.2285L14.4007 30.7783L22.8663 35.2285L21.2488 25.802L28.0992 19.1255L18.6335 17.7494L14.4007 9.1729L10.1657 17.7494L0.700027 19.1255Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3902 22.1356L18.6507 17.7376L14.207 14.7027L14.2353 8.80457H14.5614L14.5331 14.5331L18.8333 17.4658L25.5684 21.8617L25.3902 22.1356Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69578 34.2504L7.18701 25.7391L12.6221 24.3782L8.69578 34.2504ZM7.56094 25.9804L8.81535 33.0655L12.0829 24.8478L7.56094 25.9804Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6074 24.8681L2.67871 21.6788L10.1508 17.3612L12.6074 24.8681ZM3.47875 21.5918L12.0987 24.3615L9.966 17.8438L3.47875 21.5918Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92874 33.9477L8.70264 33.7129L15.1051 27.5844L12.1267 24.619L18.3727 17.7644H9.53529L14.279 14.4838L14.4638 14.7533L10.581 17.4383H18.8596L21.6315 25.9713L15.4508 27.704L8.92874 33.9477ZM18.7466 18.147L15.5834 27.3279L21.2163 25.7473L18.7466 18.147ZM12.5789 24.6082L15.2573 27.2735L18.3683 18.2535L12.5789 24.6082Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9858 33.4941C18.9684 33.4941 18.9518 33.4919 18.9358 33.4876C18.8684 33.4745 18.8075 33.4332 18.7706 33.3745L14.9204 27.2242L22.4229 30.5222L19.1489 33.4376C19.0924 33.4753 19.038 33.4941 18.9858 33.4941ZM15.7574 27.9504L19.0032 33.131L21.8251 30.6157L15.7574 27.9504Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5569 31.0068L14.2417 30.9198L15.1809 27.5436L15.4961 27.6305L14.5569 31.0068Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0291 8.81954H12.7681V6.96729H16.0291V8.81954ZM13.0942 8.49344H15.703V7.29339H13.0942V8.49344Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5615 7.12486H14.2354V-61.0001H14.5615V7.12486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearInReviewStar);
export default __webpack_public_path__ + "static/media/yearInReviewStar.b963b3b0253102b4ff5203ef6e3bf8fa.svg";
export { ForwardRef as ReactComponent };